import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'

import { observer } from 'mobx-react'

import Callout from 'modules/core/components/Callout'
import SafeLocalStorage from 'modules/core/lib/SafeLocalStorage'
import i18n from 'modules/core/lib/i18n'

const DefinitionBanner = ({}) => {
  const localStorageShowBanner = SafeLocalStorage.getItem(
    LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.WorkedDefinitionBanner,
    null
  )
  const strToBoolean = () => (localStorageShowBanner === 'false' ? false : true)

  const [showBanner, setSetBanner] = React.useState<boolean>(
    localStorageShowBanner === null ? true : strToBoolean()
  )

  const onClose = () => {
    setSetBanner(false)
    SafeLocalStorage.setItem(LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.WorkedDefinitionBanner, false)
  }

  if (showBanner === false) return null

  return (
    <Box paddingBottom="s16">
      <Callout
        type="info"
        title={i18n.t('clock_in.sidepanel.clocked.definition_banner.title')}
        description={i18n.t('clock_in.sidepanel.clocked.definition_banner.description')}
        onRemove={onClose}
      />
    </Box>
  )
}

export default observer(DefinitionBanner)
